import { vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5828299b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "switch",
  ref: "switchRef"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "search-com" }
const _hoisted_4 = { class: "point-switch" }
const _hoisted_5 = {
  key: 0,
  class: "switch-item"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "source-container" }
const _hoisted_9 = { class: "tabs" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Item = _resolveComponent("Item")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bottom-bar", _ctx.switchShow ? '' : 'no-show'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["flex", _ctx.clusterChecked ? 'on' : 'off']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchChange('cluster')))
      }, " 聚合 ", 2), [
        [_vShow, _ctx.clusterCheckedShow]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["flex", _ctx.pmChecked ? 'on' : 'off']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchChange('pm')))
      }, " 站点 ", 2), [
        [_vShow, _ctx.pmCheckedShow && _ctx.isAPictureSwitch]
      ]),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["flex", _ctx.diffDiagramChecked ? 'on' : 'off']),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchChange('diffDiagram')))
      }, " 插值图 ", 2), [
        [_vShow, _ctx.diffDiagramCheckedShow && _ctx.isAPictureSwitch]
      ])
    ], 512),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Select, {
          class: "search",
          value: _ctx.searchVal,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchVal) = $event)),
          "show-search": "",
          allowClear: "",
          placeholder: "请输入站点名称",
          "default-active-first-option": false,
          "filter-option": false,
          "not-found-content": null,
          listHeight: 200,
          onSearch: _ctx.searchPoint,
          onChange: _ctx.searchChange
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_SearchOutlined, { class: "search-icon" })
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchValData, (item) => {
              return (_openBlock(), _createBlock(_component_Option, {
                value: item.id ?? item.name,
                key: item.id,
                lon: item.lon,
                lat: item.lat,
                type: item.type,
                name: item.name ?? item.pointName
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name ?? item.pointName), 1)
                ]),
                _: 2
              }, 1032, ["value", "lon", "lat", "type", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value", "onSearch", "onChange"])
      ], 512), [
        [_vShow, _ctx.switchShow && _ctx.isAPictureSwitch]
      ]),
      _withDirectives(_createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchsInfos.pm, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.key
          }, [
            (item.children && item.children.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_Dropdown, null, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_Menu, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (itemM) => {
                            return (_openBlock(), _createBlock(_component_Item, {
                              key: itemM.key
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Checkbox, {
                                  checked: itemM.isChecked,
                                  onChange: ($event: any) => (_ctx.switchClick(itemM, item.key, index))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(itemM.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["checked", "onChange"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: _normalizeClass(["ant-dropdown-link dropdown-link", item.isChecked ? 'open' : '']),
                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                        _createVNode(_component_DownOutlined)
                      ], 2)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            (!item.children)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "switch-item",
                  onClick: ($event: any) => (_ctx.switchClick(item, false))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['iconfont', item.icons]),
                    style: _normalizeStyle(item.isChecked ? { color: '#4094FD' } : '')
                  }, null, 6),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.currentMapStyle)
                  }, _toDisplayString(item.name), 3)
                ], 8, _hoisted_6))
              : _createCommentVNode("", true),
            (item.children && item.children.length === 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "switch-item",
                  onClick: ($event: any) => (_ctx.switchClick(item.children[0], false))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['iconfont', item.children[0]?.icons]),
                    style: _normalizeStyle(item.children[0]?.isChecked ? { color: '#4094FD' } : '')
                  }, null, 6),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.currentMapStyle)
                  }, _toDisplayString(item.children[0]?.name), 3)
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.switchShow]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createElementVNode("ul", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchsInfos.source, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: _normalizeClass(_ctx.activeTab === item.id ? 'active' : ''),
              onClick: ($event: any) => (_ctx.changeTab(item.id))
            }, _toDisplayString(item.name), 11, _hoisted_10))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchsInfos.source, (item) => {
          return _withDirectives((_openBlock(), _createElementBlock("ul", {
            class: "tabs-content",
            key: item.id
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.buttonChildren, (i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i.id,
                onClick: ($event: any) => (_ctx.switchClick(i, false))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["iconfont", [i.icons, i.isChecked ? 'active' : '']])
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(i.name), 1)
              ], 8, _hoisted_11))
            }), 128))
          ])), [
            [_vShow, _ctx.activeTab === item.id]
          ])
        }), 128))
      ], 512), [
        [_vShow, _ctx.switchShow]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["legend", _ctx.indexName])
    }, null, 2)
  ], 2))
}